import { DashboardWidgetType } from 'features/dashboard/types'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const generateStaticStrategy = (): WidgetSettingComposingStrategy => ({
  canBeDrilledDown: () => true,
  isOverMaxInput: () => false,
  composeDrillDownWidgetSetting: (widgetSetting: DashboardWidgetType) => widgetSetting
})

export default generateStaticStrategy
